import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  CommunicationTemplateDto,
  CreateCommunicationTemplateDto,
  ResponseDto,
} from "@mimber/schema"
import { communicationTemplatesKeys } from "../communication-templates.utils"

export const useCreateCommunicationTemplate = (
  options?: UseMutationOptions<
    ResponseDto<CommunicationTemplateDto>,
    Error,
    CreateCommunicationTemplateDto
  >
): UseMutationResult<
  ResponseDto<CommunicationTemplateDto>,
  Error,
  CreateCommunicationTemplateDto
> => {
  guardAppUsage("mimber-organization", "useCreateCommunicationTemplate")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data: CreateCommunicationTemplateDto) => {
      const response = await server.post<ResponseDto<CommunicationTemplateDto>>(
        "communication-templates",
        data
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: communicationTemplatesKeys.findAll(),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
